/**
 * Number of applications by five underwriting/ re-underwriting, by place of Residence of Insured Person
 */
import {
	isHongKongResident,
	countAccpetedRejectedOffersMatchingPlan,
	countAccpetedRejectedOffersMatchingPlanWithLoadingsOnly,
	countAccpetedRejectedOffersMatchingPlanWithExclusionsOnly,
	countAccpetedRejectedOffersMatchingPlanWithLoadingsAndExclusions
} from "./helpers.js"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const header = [
	[
		"Template A2 - Number of accepted/rejected offer of customers by four Underwriting/ Re-underwriting results, by Place of Residence of Insured Person"
	],
	[
		"Place of Residence",
		"Standard Plan",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"Flexi Plan"
	],
	[
		"",
		"Standard Offer",
		"",
		"Offer with Premium Loading only",
		"",
		"Offer with CBE only",
		"",
		"Offer with Premium Loading and CBE",
		"",
		"Standard Offer",
		"",
		"Offer with Premium Loading only",
		"",
		"Offer with CBE only",
		"",
		"Offer with Premium Loading and CBE",
		""
	],
	[
		"",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject"
	]
]

const rows = payload => [
	[
		"Hong Kong",
		countStandardOffer(true, payload, "S00027", true),
		countStandardOffer(true, payload, "S00027", false),
		countOfferWithLoadings(true, payload, "S00027", true),
		countOfferWithLoadings(true, payload, "S00027", false),
		countOfferWithExclusions(true, payload, "S00027", true),
		countOfferWithExclusions(true, payload, "S00027", false),
		countOfferWithLoadingsAndExclusions(true, payload, "S00027", true),
		countOfferWithLoadingsAndExclusions(true, payload, "S00027", false),
		countStandardOffer(true, payload, "F00038", true),
		countStandardOffer(true, payload, "F00038", false),
		countOfferWithLoadings(true, payload, "F00038", true),
		countOfferWithLoadings(true, payload, "F00038", false),
		countOfferWithExclusions(true, payload, "F00038", true),
		countOfferWithExclusions(true, payload, "F00038", false),
		countOfferWithLoadingsAndExclusions(true, payload, "F00038", true),
		countOfferWithLoadingsAndExclusions(true, payload, "F00038", false)
	],
	[
		"Others",
		countStandardOffer(false, payload, "S00027", true),
		countStandardOffer(false, payload, "S00027", false),
		countOfferWithLoadings(false, payload, "S00027", true),
		countOfferWithLoadings(false, payload, "S00027", false),
		countOfferWithExclusions(false, payload, "S00027", true),
		countOfferWithExclusions(false, payload, "S00027", false),
		countOfferWithLoadingsAndExclusions(false, payload, "S00027", true),
		countOfferWithLoadingsAndExclusions(false, payload, "S00027", false),
		countStandardOffer(false, payload, "F00038", true),
		countStandardOffer(false, payload, "F00038", false),
		countOfferWithLoadings(false, payload, "F00038", true),
		countOfferWithLoadings(false, payload, "F00038", false),
		countOfferWithExclusions(false, payload, "F00038", true),
		countOfferWithExclusions(false, payload, "F00038", false),
		countOfferWithLoadingsAndExclusions(false, payload, "F00038", true),
		countOfferWithLoadingsAndExclusions(false, payload, "F00038", false)
	]
]

const countStandardOffer = (isPlaceOfResidence, cases, plan, isAccepted) => {
	const filteredCases = cases.map(item => {
		let address = item?.insureds?.[0]?.addresses
		let resident = isHongKongResident(address)
		let countOffers = countAccpetedRejectedOffersMatchingPlan(
			item?.proposals,
			plan,
			isAccepted
		)
		if (resident === isPlaceOfResidence) {
			return countOffers
		} else return 0
	})
	return filteredCases?.reduce((total, item) => {
		return (total += item)
	}, 0)
}

const countOfferWithLoadings = (
	isPlaceOfResidence,
	cases,
	plan,
	isAccepted
) => {
	const filteredCases = cases.map(item => {
		let address = item?.insureds?.[0]?.addresses
		let resident = isHongKongResident(address)
		let countOffers = countAccpetedRejectedOffersMatchingPlanWithLoadingsOnly(
			item?.proposals,
			plan,
			isAccepted
		)
		if (resident === isPlaceOfResidence) {
			return countOffers
		} else return 0
	})
	return filteredCases?.reduce((total, item) => {
		return (total += item)
	}, 0)
}

const countOfferWithExclusions = (
	isPlaceOfResidence,
	cases,
	plan,
	isAccepted
) => {
	const filteredCases = cases.map(item => {
		let address = item?.insureds?.[0]?.addresses
		let resident = isHongKongResident(address)
		let countOffers = countAccpetedRejectedOffersMatchingPlanWithExclusionsOnly(
			item?.proposals,
			plan,
			isAccepted
		)
		if (resident === isPlaceOfResidence) {
			return countOffers
		} else return 0
	})
	return filteredCases?.reduce((total, item) => {
		return (total += item)
	}, 0)
}

const countOfferWithLoadingsAndExclusions = (
	isPlaceOfResidence,
	cases,
	plan,
	isAccepted
) => {
	const filteredCases = cases.map(item => {
		let address = item?.insureds?.[0]?.addresses
		let resident = isHongKongResident(address)
		let countOffers = countAccpetedRejectedOffersMatchingPlanWithLoadingsAndExclusions(
			item?.proposals,
			plan,
			isAccepted
		)
		if (resident === isPlaceOfResidence) {
			return countOffers
		} else return 0
	})
	return filteredCases?.reduce((total, item) => {
		return (total += item)
	}, 0)
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplateA2Payload($caseWhere: caseWhere) {
			cases(where: $caseWhere) {
				list {
					id
					insureds {
						... on individual {
							addresses {
								type
								fields2 {
									type
									value
								}
							}
						}
					}
					proposals {
						id
						status
						basket {
							product {
								productId {
									plan
								}
							}
							premium {
								loadings {
									id
								}
							}
							exclusions {
								id
							}
						}
						policies {
							id
						}
					}
				}
			}
		}
	`
	const variables = {
		caseWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.cases?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
		{ s: { r: 1, c: 0 }, e: { r: 3, c: 0 } },
		{ s: { r: 1, c: 1 }, e: { r: 1, c: 8 } },
		{ s: { r: 1, c: 9 }, e: { r: 1, c: 16 } },
		{ s: { r: 2, c: 1 }, e: { r: 2, c: 2 } },
		{ s: { r: 2, c: 3 }, e: { r: 2, c: 4 } },
		{ s: { r: 2, c: 5 }, e: { r: 2, c: 6 } },
		{ s: { r: 2, c: 7 }, e: { r: 2, c: 8 } },
		{ s: { r: 2, c: 9 }, e: { r: 2, c: 10 } },
		{ s: { r: 2, c: 11 }, e: { r: 2, c: 12 } },
		{ s: { r: 2, c: 13 }, e: { r: 2, c: 14 } },
		{ s: { r: 2, c: 15 }, e: { r: 2, c: 16 } }
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
